import moment from 'moment'
import Vue from 'vue'

Vue.filter('lowercase', (value) => {
  return value ? value.toLowerCase() : ''
})

Vue.filter('uppercase', (value) => {
  return value ? value.toUpperCase() : ''
})

Vue.filter('yymmdd', (value) => {
  return moment.utc(value).format('YYYY.MM.DD') + ' (UTC)'
})

Vue.filter('yymmddhhmm', (value) => {
  return moment.utc(value).format('YYYY.MM.DD HH:mm') + ' (UTC)'
})

Vue.filter('yymmddhhmmss', (value) => {
  return moment.utc(value).format('YYYY.MM.DD HH:mm') + ' (UTC)'
})

Vue.filter('emptyChar', (value, char = '-') => {
  if (!value) {
    return char
  }
  return value
})

Vue.filter('yesOrNo', (value, longFormat = false) => {
  let result

  if (value) {
    result = 'Yes'
  } else {
    result = 'No'
  }

  if (!longFormat) {
    result = result.substr(0, 1)
  }
  return result
})

Vue.filter('historyName', (value) => {
  switch (value) {
    case 1:
      return '승인'
    case 2:
      return '거절'
    default:
      throw new Error(`invalid historyCode: ${value}`)
  }
})

Vue.filter('hidePassword', (value) => {
  if (!value) {
    return ''
  }
  return Array(value.length + 1).join('*')
})

Vue.filter('reportShareUrl', (value) => {
  const location = window.location
  return `${location.protocol}//${location.host}/report/share/${value}`
})

Vue.filter('issueType', (value, needCheck) => {
  if (needCheck) {
    return 'Check'
  }

  switch (value) {
    case 1:
      return 'Pass'
    case 2:
      return 'Error'
    case 3:
      return 'Exception'
    default:
      throw new Error(`invalid issueType: ${value}`)
  }
})



// WEBPACK FOOTER //
// ./src/filter/index.js